import { gql } from "@apollo/client"

export const GET_ALL_CREW_MEMBERS_FOR_REPLACE_SELECT_FIELD = gql`
    query crewMemberAssignmentsForJobDay($id: Int!) {
        crewMemberAssignmentsForJobDay(id: $id) {

            id
            crewMember {
                firstName
                lastName
            }
        }
    }
`

export const GET_ALL_CREW_MEMBERS_FOR_REPLACE_WITH_SELECT_FIELD = gql`
    query crewMembersAvailableForDate($jobDay: Int!) {
        crewMembersAvailableForDate(jobDay: $jobDay) {

            id

            firstName
            lastName

        }
    }
`